<template>
  <div class="section">
    <el-collapse v-model="expandedItems">
      <el-collapse-item title="Identificação" name="1">
        <div class="section double-column">
          <div class="info2">
            <h4>Dados pessoais</h4>
            <p><strong>Nome:</strong> {{ pessoa.nomeRazaoSocial }}</p>
            <p>
              <strong>CPF:</strong>
              {{ pessoa.cpfCnpjPassaporteFormatado }}
            </p>
            <p>
              <strong>Sexo:</strong>
              {{ pessoa.pessoaFisica.sexo.nome }}
            </p>
            <p>
              <strong>Data de nascimento:</strong>
              {{ dataNascimentoExibicao }}
            </p>
            <p>
              <strong>Nome da Mãe:</strong> {{ pessoa.pessoaFisica.nomeMae }}
            </p>
          </div>
          <div class="info2" v-if="!pessoa.pessoaFisica.estrangeiro">
            <h4>Endereço principal</h4>
            <p>
              <strong>CEP:</strong>
              {{ formatarCEP(pessoa.endereco.cep) }}
            </p>
            <p>
              <strong>Logradouro:</strong>
              {{ pessoa.endereco.logradouro }}
            </p>
            <p>
              <strong>Bairro:</strong>
              {{ pessoa.endereco.bairro }}
            </p>
            <p v-if="pessoa.endereco.municipio">
              <strong>Município:</strong>
              {{ pessoa.endereco.municipio.nome }}
            </p>
            <p
              v-if="
                pessoa.endereco.municipio && pessoa.endereco.municipio.estado
              "
            >
              <strong>UF:</strong>
              {{ pessoa.endereco.municipio.estado.nome }}
            </p>
          </div>
          <div class="info2" v-if="pessoa.pessoaFisica.estrangeiro">
            <h4>Endereço estrangeiro</h4>
            <p>
              <strong>ZIP/Postal Code:</strong>
              {{ formatarCEP(pessoa.endereco.cep) }}
            </p>
            <p v-if="pessoa.endereco.pais">
              <strong>Country:</strong>
              {{ pessoa.endereco.pais.nomeEn }}
            </p>
            <p>
              <strong>City:</strong>
              {{ pessoa.endereco.municipioInternacional }}
            </p>
            <p>
              <strong>State/Province/Region:</strong>
              {{ pessoa.endereco.estadoInternacional }}
            </p>
            <p>
              <strong>Address Line 1:</strong>
              {{ pessoa.endereco.logradouro }}
            </p>
            <p>
              <strong>Address Line 2:</strong>
              {{ pessoa.endereco.complemento }}
            </p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Informações complementares" name="2">
        <div class="info2 padding">
          <p>
            Modalidade de pesca:
            <strong>{{
              (function() {
                const modalidadeSelecionada = listaOpcoes.modalidadesPesca.find(
                  modalidade =>
                    modalidade.cod === informacoesComplementares.modalidadePesca
                );
                return modalidadeSelecionada
                  ? modalidadeSelecionada.descricao_pt
                  : "Não informado";
              })()
            }}</strong>
          </p>
          <p>
            Valor a pagar:
            <strong>
              R$
              {{
                calcularPreco(informacoesComplementares.modalidadePesca)
              }}</strong
            >
          </p>
          <p class="info2 small-text">
            Validade da carteira: 02 anos
          </p>
          <p>
            Em média quantos dias por ano costuma pescar:
            <strong>{{ informacoesComplementares.diasPescaPorAno }}</strong>
          </p>
          <p>
            Qual peixe você costuma pescar:
            <span>
              <strong>
                {{
                  Array.isArray(informacoesComplementares.peixeMaisPescado)
                    ? informacoesComplementares.peixeMaisPescado
                        .map(cod => {
                          const peixeSelecionado = listaOpcoes.peixesMaisPescados.find(
                            peixe => peixe.cod === cod
                          );
                          return peixeSelecionado
                            ? peixeSelecionado.descricao_pt
                            : "Não informado";
                        })
                        .join(", ")
                    : (() => {
                        const peixeSelecionado = listaOpcoes.peixesMaisPescados.find(
                          peixe =>
                            peixe.cod ===
                            informacoesComplementares.peixeMaisPescado
                        );
                        return peixeSelecionado
                          ? peixeSelecionado.descricao_pt
                          : "Não informado";
                      })()
                }}
              </strong>
            </span>
          </p>
          <p>
            Equipamentos utilizados:
            <strong>{{
              informacoesComplementares.equipamentos.join(", ")
            }}</strong>
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="actions">
      <el-button class="green-border" @click="$emit('voltar')"
        >Voltar</el-button
      >
      <el-button type="primary" @click="$emit('confirmar')"
        >Confirmar</el-button
      >
    </div>
  </div>
</template>

<script>
import { calcularPreco } from "@/utils/calculoPreco";
import { formatarCEP } from "@/utils/layout/mascarasFormat.js";

export default {
  name: "ResumoCadastro",
  props: {
    pessoa: {
      type: Object,
      required: true
    },
    informacoesComplementares: Object,
    listaOpcoes: Object
  },
  data() {
    return {
      expandedItems: ["1", "2"]
    };
  },
  computed: {
    dataNascimentoExibicao() {
      const s = this.pessoa.pessoaFisica.dataNascimento;
      const m = typeof s === "string" && /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
      return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
    }
  },
  methods: {
    calcularPreco,
    formatarCEP
  }
};
</script>

<style>
.el-collapse-item__header {
  line-height: normal !important;
}
</style>

<style scoped>
/* Estilos específicos para o componente */
.section {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
}

.double-column {
  display: flex;
  flex-direction: row;
  gap: 10rem;
}

.info2 {
  margin: 10px 0;
}

.info2.padding {
  padding: 10px;
}

.small-text {
  font-size: 12px;
  margin-bottom: 15px;
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}

.el-button.green-border {
  border-radius: 20px;
  padding: 10px 40px !important;
}

.el-button--primary {
  background-color: #00c254;
  color: #fff;
  border-radius: 20px !important;
  font-size: 14px;
  padding: 10px 40px !important;
}

@media (max-width: 768px) {
  .double-column {
    flex-direction: column;
    gap: 2rem;
  }

  .info2 {
    margin: 10px 0;
    padding: 0 10px;
  }

  .actions {
    flex-direction: column;
    gap: 10px;
  }

  .el-button.green-border,
  .el-button--primary {
    width: 100%;
    padding: 10px !important;
  }
}
</style>
